import React from 'react';

// Пустой шаблон для новых иконок
interface EmptyProps {
  w?: number;
  h?: number;
}

export const Empty: React.FC<EmptyProps> = ({ w = 40, h = 40 }) => {
  return (
    <svg
      width={w ? w : '50'}
      height={h ? h : '50'}
      viewBox="0 0 256 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/*код вставить сюда*/}
    </svg>
  );
};

//Курьер по москве
export const CourierMoscowIcon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6422 2.40996V3.23655C14.4965 5.70709 12.4853 5.72821 12.4853 5.72821C11.938 5.69672 11.4195 5.47221 11.022 5.09456C10.6245 4.71691 10.3738 4.21059 10.3143 3.66555L10.2824 3.40338L10.2168 2.8655L10.122 2.09038C10.1025 1.9157 10.1176 1.7389 10.1665 1.57006C10.2153 1.40123 10.297 1.24367 10.4067 1.1064C10.5165 0.96912 10.6522 0.854817 10.8062 0.770016C10.9601 0.685215 11.1293 0.631578 11.3039 0.61217L13.0736 0.414462C13.4263 0.375218 13.7802 0.477685 14.0574 0.699328C14.3346 0.920972 14.5124 1.24364 14.5518 1.59638L14.6124 2.14184L14.6422 2.40996Z"
        fill="#FED9B9"
      />
      <path
        d="M16.5332 5.53271H23.953V12.934H16.5332V5.53271Z"
        fill="#FCBD55"
      />
      <path
        d="M20.4841 12.2803H23.9508V5.53271H17.5342V9.3298C17.5342 10.1122 17.845 10.8626 18.3982 11.4159C18.9514 11.9692 19.7017 12.2801 20.4841 12.2803V12.2803Z"
        fill="#FCCA6E"
      />
      <path
        d="M16.8512 11.5056H16.8425C16.7319 11.5057 16.624 11.4718 16.5332 11.4087V11.8816C16.6329 11.9151 16.7373 11.9323 16.8425 11.9325H16.8674L18.9322 11.8361C18.7459 11.7211 18.573 11.5857 18.4166 11.4325L16.8512 11.5056Z"
        fill="#FCAC44"
      />
      <path
        d="M21.5804 11.2954H21.5582C21.4016 11.2954 19.7263 11.3718 18.4165 11.4325C18.5729 11.5855 18.7459 11.7206 18.9322 11.8355C20.1623 11.7786 21.3491 11.7271 21.5425 11.7222L22.2212 11.8452L23.9545 11.83V11.4081L22.2591 11.4184L21.5804 11.2954Z"
        fill="#FCBD55"
      />
      <path
        d="M14.2625 16.6671L13.9105 17.5176C13.6676 17.4168 13.4338 17.2953 13.2117 17.1546C12.5429 16.705 11.9612 16.1379 11.4946 15.4809L11.825 13.9805C11.9063 14.5709 12.475 15.5188 13.7155 16.3855C13.8895 16.4947 14.0725 16.589 14.2625 16.6671V16.6671Z"
        fill="#40A6C2"
      />
      <path
        d="M19.2773 5.53271H21.1867V7.44209H19.2773V5.53271Z"
        fill="#FF953F"
      />
      <path
        d="M20.3971 7.1458H21.1869V5.53271H19.7368V6.48605C19.7368 6.57273 19.7539 6.65857 19.7871 6.73865C19.8203 6.81873 19.8689 6.89148 19.9302 6.95275C19.9916 7.01402 20.0644 7.06261 20.1445 7.09573C20.2246 7.12886 20.3104 7.14587 20.3971 7.1458Z"
        fill="#F99E4D"
      />
      <path
        d="M22.2034 23.8714C22.1896 23.7913 22.1598 23.7148 22.1158 23.6466C22.0717 23.5783 22.0144 23.5196 21.9471 23.4741C21.8798 23.4286 21.804 23.3971 21.7242 23.3816C21.6445 23.3661 21.5624 23.3669 21.483 23.3839L21.185 23.4381L20.0205 16.7268C19.9937 16.5774 19.9335 16.436 19.8444 16.3131C19.7553 16.1902 19.6396 16.0891 19.5059 16.0172L15.7196 13.9806L15.5084 10.7793L14.7717 10.1347L16.153 8.65056C15.3838 7.73514 14.23 6.61389 14.0459 6.42973C13.6488 6.05746 13.1484 5.81389 12.6105 5.73098C11.7817 5.67681 10.8555 6.18598 10.8555 7.09056C10.8555 7.55098 11.0884 9.19223 11.3267 10.7631C11.3267 10.7631 11.798 13.7531 11.825 13.9806L10.7634 18.7851C10.7408 18.9081 10.6732 19.0182 10.5738 19.0939L6.62449 22.2085L6.61962 22.2123L5.70962 22.8244C5.65627 22.8742 5.62256 22.9415 5.61461 23.014C5.60666 23.0866 5.62499 23.1596 5.66629 23.2198L7.36712 25.5923L8.00629 25.1644C8.07221 25.117 8.12798 25.0569 8.17032 24.9877C8.21267 24.9184 8.24072 24.8414 8.25284 24.7611C8.26495 24.6809 8.26088 24.599 8.24087 24.5203C8.22085 24.4417 8.18529 24.3678 8.13629 24.3031L7.9792 24.0919L12.6863 20.3273C12.7667 20.2647 12.827 20.18 12.8596 20.0835L14.2625 16.6656C15.3311 17.0546 16.4287 17.3588 17.545 17.5756C17.6052 17.5864 17.6605 17.6156 17.7032 17.6593C17.7459 17.703 17.774 17.759 17.7834 17.8194L18.9209 23.9288L19.1094 24.9423C19.1314 25.0111 19.1774 25.0698 19.2391 25.1075C19.3007 25.1453 19.3739 25.1597 19.4452 25.1481L22.316 24.6281L22.2034 23.8714Z"
        fill="#F99E4D"
      />
      <path
        d="M13.0735 0.414444L11.3039 0.611611C10.9512 0.650945 10.6285 0.828769 10.4068 1.10598C10.1852 1.38318 10.0827 1.73707 10.122 2.08982L10.2487 3.12928L14.6422 2.40994L14.5517 1.59744C14.5324 1.42269 14.4788 1.25346 14.394 1.09942C14.3093 0.945385 14.195 0.809556 14.0577 0.699698C13.9204 0.589839 13.7629 0.508102 13.594 0.459157C13.4251 0.410213 13.2483 0.395019 13.0735 0.414444V0.414444Z"
        fill="#EB7729"
      />
      <path
        d="M6.61962 22.2139L5.70962 22.826C5.65627 22.8758 5.62256 22.9431 5.61461 23.0157C5.60666 23.0882 5.62499 23.1612 5.66629 23.2214L7.36712 25.5939L8.00629 25.166C8.07221 25.1186 8.12798 25.0586 8.17032 24.9893C8.21267 24.9201 8.24072 24.843 8.25284 24.7628C8.26495 24.6825 8.26088 24.6006 8.24087 24.522C8.22085 24.4433 8.18529 24.3695 8.13629 24.3047L7.9792 24.0935L6.62449 22.2085L6.61962 22.2139Z"
        fill="#323648"
      />
      <path
        d="M11.8251 13.9805L10.7634 18.7851C10.7408 18.908 10.6732 19.0181 10.5738 19.0938L6.62451 22.2084L7.97868 24.0918L12.6858 20.3272C12.7662 20.2647 12.8264 20.1799 12.8591 20.0834L14.262 16.6655C14.072 16.5873 13.889 16.4931 13.7149 16.3838C12.4751 15.5188 11.9063 14.5709 11.8251 13.9805V13.9805Z"
        fill="#EB7729"
      />
      <path
        d="M12.4679 15.9971C12.4445 15.9721 12.4147 15.954 12.3817 15.9448C12.3488 15.9355 12.3139 15.9354 12.2809 15.9445C12.2479 15.9536 12.218 15.9715 12.1945 15.9963C12.1709 16.0212 12.1546 16.052 12.1472 16.0854L11.5129 18.9562C11.4904 19.0792 11.4228 19.1892 11.3234 19.265L8.21528 21.7176C7.98857 21.896 7.83947 22.155 7.7991 22.4406C7.75873 22.7262 7.83021 23.0164 7.99862 23.2506L8.37778 23.7754L12.6867 20.3294C12.7671 20.2668 12.8274 20.1821 12.8601 20.0856L14.0436 17.2023C13.8959 17.1305 13.7525 17.0502 13.6141 16.9618C13.2028 16.6766 12.8191 16.3536 12.4679 15.9971V15.9971Z"
        fill="#FF953F"
      />
      <path
        d="M21.115 23.0351L20.0203 16.7268C19.9936 16.5774 19.9334 16.436 19.8443 16.3131C19.7552 16.1902 19.6394 16.0891 19.5057 16.0173L15.7195 13.9806L15.5061 10.7474L14.8138 10.1445L16.11 8.74646L16.0873 8.72101L16.1544 8.64896C15.3853 7.73355 14.2315 6.6123 14.0474 6.42813C13.6503 6.05586 13.1499 5.8123 12.6119 5.72938C12.2869 5.70901 11.9621 5.77086 11.6673 5.90922C11.5541 6.09721 11.4949 6.31272 11.4961 6.53213C11.4961 6.99255 11.729 8.6338 11.9674 10.2046C11.9674 10.2046 12.4386 13.1946 12.4657 13.4221C12.5469 14.0125 13.1157 14.9605 14.3561 15.8271C14.5301 15.9364 14.7132 16.0306 14.9032 16.1088C15.9718 16.4978 17.0694 16.802 18.1857 17.0188C18.2458 17.0296 18.3011 17.0588 18.3439 17.1025C18.3866 17.1462 18.4146 17.2022 18.424 17.2625L19.3286 22.117C19.359 22.2799 19.4217 22.4352 19.5132 22.5735C19.6047 22.7117 19.7229 22.8303 19.861 22.922C19.9991 23.0137 20.1542 23.0768 20.3172 23.1075C20.4801 23.1382 20.6475 23.1358 20.8095 23.1006L21.115 23.0351Z"
        fill="#FCAC44"
      />
      <path
        d="M15.5083 10.7793L13.5864 9.1001V9.15426C13.5865 9.2358 13.604 9.31638 13.6378 9.39057C13.6716 9.46477 13.721 9.53084 13.7825 9.58435L15.5294 11.0988L15.5083 10.7793Z"
        fill="#F99E4D"
      />
      <path
        d="M22.2033 23.8712C22.1895 23.7912 22.1598 23.7147 22.1157 23.6464C22.0717 23.5781 22.0143 23.5195 21.947 23.4739C21.8797 23.4284 21.8039 23.3969 21.7241 23.3814C21.6444 23.3659 21.5623 23.3667 21.4829 23.3837L21.185 23.4379L18.9219 23.9303L19.1104 24.9437C19.1324 25.0126 19.1784 25.0712 19.2401 25.109C19.3017 25.1468 19.3749 25.1612 19.4462 25.1496L22.317 24.6296L22.2033 23.8712Z"
        fill="#323648"
      />
      <path
        d="M16.5749 2.3671L14.6406 2.6856L10.2823 3.40277L10.2168 2.8649L14.6124 2.14177L16.4882 1.83248C16.5591 1.82077 16.6318 1.83771 16.6902 1.87956C16.7486 1.92141 16.788 1.98475 16.7997 2.05565C16.8114 2.12654 16.7944 2.19918 16.7526 2.25759C16.7107 2.316 16.6474 2.3554 16.5765 2.3671H16.5749Z"
        fill="#EB7729"
      />
      <path
        d="M8.3735 15.4995H6.11475C6.007 15.4995 5.90367 15.4567 5.82748 15.3805C5.7513 15.3043 5.7085 15.201 5.7085 15.0933C5.7085 14.9855 5.7513 14.8822 5.82748 14.806C5.90367 14.7298 6.007 14.687 6.11475 14.687H8.3735C8.48124 14.687 8.58457 14.7298 8.66076 14.806C8.73695 14.8822 8.77975 14.9855 8.77975 15.0933C8.77975 15.201 8.73695 15.3043 8.66076 15.3805C8.58457 15.4567 8.48124 15.4995 8.3735 15.4995Z"
        fill="#585F76"
      />
      <path
        d="M7.41745 13.3354H2.04736C1.93962 13.3354 1.83629 13.2926 1.7601 13.2165C1.68391 13.1403 1.64111 13.0369 1.64111 12.9292C1.64111 12.8215 1.68391 12.7181 1.7601 12.6419C1.83629 12.5658 1.93962 12.5229 2.04736 12.5229H7.41745C7.52519 12.5229 7.62852 12.5658 7.70471 12.6419C7.7809 12.7181 7.8237 12.8215 7.8237 12.9292C7.8237 13.0369 7.7809 13.1403 7.70471 13.2165C7.62852 13.2926 7.52519 13.3354 7.41745 13.3354V13.3354Z"
        fill="#585F76"
      />
      <path
        d="M12.3437 11.1721H9.22266C9.11491 11.1721 9.01158 11.1293 8.93539 11.0531C8.85921 10.9769 8.81641 10.8736 8.81641 10.7659C8.81641 10.6581 8.85921 10.5548 8.93539 10.4786C9.01158 10.4024 9.11491 10.3596 9.22266 10.3596H12.3437C12.4515 10.3596 12.5548 10.4024 12.631 10.4786C12.7072 10.5548 12.75 10.6581 12.75 10.7659C12.75 10.8736 12.7072 10.9769 12.631 11.0531C12.5548 11.1293 12.4515 11.1721 12.3437 11.1721Z"
        fill="#585F76"
      />
      <path
        d="M9.22261 9.00806H4.75928C4.65153 9.00806 4.5482 8.96526 4.47202 8.88907C4.39583 8.81288 4.35303 8.70955 4.35303 8.60181C4.35303 8.49406 4.39583 8.39073 4.47202 8.31454C4.5482 8.23836 4.65153 8.19556 4.75928 8.19556H9.22261C9.33035 8.19556 9.43369 8.23836 9.50987 8.31454C9.58606 8.39073 9.62886 8.49406 9.62886 8.60181C9.62886 8.70955 9.58606 8.81288 9.50987 8.88907C9.43369 8.96526 9.33035 9.00806 9.22261 9.00806Z"
        fill="#585F76"
      />
      <path
        d="M22.4859 9.62824L21.8733 9.98899L17.4251 9.83299C17.2731 9.81913 17.1305 9.75355 17.021 9.6472L16.0872 8.72095L14.7715 10.1293L16.338 11.5208C16.4809 11.6491 16.6671 11.7184 16.8591 11.7147C16.8591 11.7147 21.3327 11.5035 21.5618 11.5046L22.2405 11.6275L23.9544 11.6129V9.57624L22.4859 9.62824Z"
        fill="#FED9B9"
      />
    </svg>
  );
};

// Иконка службы доставки (коробка)
interface DeliveryServiceIconProps {
  w?: number;
  h?: number;
}
export const DeliveryServiceIcon: React.FC<DeliveryServiceIconProps> = ({
  w = 40,
  h = 40
}) => {
  return (
    <svg
      width={w ? w : 50}
      height={h ? h : 50}
      viewBox="0 0 248 206"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72.8855 145.851C75.0945 145.851 76.8855 147.642 76.8855 149.851C76.8855 152.06 75.0945 153.851 72.8855 153.851H4.5C2.291 153.851 0.5 152.06 0.5 149.851C0.5 147.642 2.291 145.851 4.5 145.851H72.8855ZM71.2995 99.0008C73.5085 99.0008 75.2995 100.792 75.2995 103.001C75.2995 105.21 73.5085 107.001 71.2995 107.001H28.3095C26.1005 107.001 24.3095 105.21 24.3095 103.001C24.3095 100.792 26.1005 99.0008 28.3095 99.0008H71.2995ZM76.7805 5.30078C78.9895 5.30078 80.7805 7.09178 80.7805 9.30078C80.7805 11.5098 78.9895 13.3008 76.7805 13.3008H23.31C21.101 13.3008 19.31 11.5098 19.31 9.30078C19.31 7.09178 21.101 5.30078 23.31 5.30078H76.7805ZM106.834 13.3008C104.625 13.3008 102.834 11.5098 102.834 9.30078C102.834 7.09178 104.625 5.30078 106.834 5.30078H157.693C159.902 5.30078 161.693 7.09178 161.693 9.30078C161.693 11.5098 159.902 13.3008 157.693 13.3008H106.834ZM4.5005 55.1508C2.2915 55.1508 0.5005 53.3598 0.5005 51.1508C0.5005 48.9418 2.2915 47.1508 4.5005 47.1508H72.8855C75.0945 47.1508 76.8855 48.9418 76.8855 51.1508C76.8855 53.3598 75.0945 55.1508 72.8855 55.1508H4.5005Z"
        fill="#D1D1D6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M153.509 1.71413L72.0643 48.7361C69.4048 50.2711 67.8828 52.9076 67.8828 55.9786V150.023C67.8828 153.093 69.4048 155.73 72.0643 157.265L153.509 204.287C156.168 205.823 159.213 205.823 161.872 204.287L243.316 157.265C245.976 155.73 247.498 153.094 247.498 150.023V55.9786C247.498 52.9081 245.976 50.2716 243.316 48.7361L161.872 1.71413C159.213 0.178625 156.169 0.178625 153.509 1.71413Z"
        fill="#F2D1A5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.9763 51.7812C68.2658 53.0117 67.8853 54.4332 67.8828 55.9622V150.038C67.8883 153.102 69.4093 155.732 72.0643 157.265L153.509 204.287C154.839 205.055 156.265 205.438 157.69 205.438V103L68.9763 51.7812Z"
        fill="#E3A76F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M153.51 1.71413L72.0646 48.7361C70.7351 49.5036 69.6896 50.5466 68.9766 51.7811L157.691 103.001L246.405 51.7811C245.692 50.5461 244.647 49.5036 243.317 48.7361L161.872 1.71413C159.213 0.178625 156.169 0.178625 153.51 1.71413Z"
        fill="#C48958"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M215.617 69.5575L189.573 84.594L99.7656 32.7435L125.81 17.707L215.617 69.5575Z"
        fill="#D1D1D6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M192.714 123.618L213.531 111.599C214.861 110.831 215.622 109.513 215.622 107.978V69.5566L189.578 84.5931V121.807C189.578 122.575 189.959 123.234 190.624 123.618C191.288 124.002 192.049 124.002 192.714 123.618Z"
        fill="#ECEFF1"
      />
    </svg>
  );
};

// Иконка отправка почтой России (лого ПР)
interface MailOfRussiaServiceIconProps {
  w?: number;
  h?: number;
}
export const MailOfRussiaServiceIcon: React.FC<
  MailOfRussiaServiceIconProps
> = ({ w = 40, h = 40 }) => {
  return (
    <svg
      width={w ? w : '50'}
      height={h ? h : '50'}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 99.985H99.9993V0H0V99.985Z" fill="#0055A5" />
      <path
        d="M9.15625 54.7949V75.6414H12.5932V69.5888C13.2651 70.1722 14.0051 70.5224 14.7976 70.5224C15.9333 70.5224 16.867 69.9247 17.5998 68.7293C18.4223 67.3987 18.8323 65.4345 18.8323 62.8643C18.8323 61.0711 18.5036 59.4572 17.8616 58.0824L17.7492 57.8576L17.6369 57.6712L17.5616 57.4847L17.4492 57.3353L17.3368 57.1488L17.1874 56.9623L17.075 56.8129L16.9626 56.6634L16.8132 56.514L16.7008 56.3646L16.5514 56.2151L16.402 56.1028L16.2525 55.9533L16.1031 55.841L15.9537 55.7286L15.8042 55.6161L15.6177 55.5421L15.4683 55.4297L15.3189 55.3556L15.1324 55.2815L14.9459 55.2062L14.7594 55.1309L14.5729 55.0567L14.3864 55.0197L14.1999 54.9826L14.0134 54.9455L13.7899 54.8714H13.6034L13.3798 54.8343H13.1933L12.9686 54.7973H12.745H9.15625V54.7949ZM12.4067 57.7465H12.7426C13.6094 57.7465 14.2824 58.2474 14.7594 59.2038C15.2376 60.1601 15.4695 61.6389 15.4695 63.6868C15.4695 64.7926 15.3344 65.6665 15.0212 66.2642C14.7223 66.8619 14.3338 67.1608 13.901 67.1608C13.4826 67.1608 13.1383 66.8775 12.855 66.3383C12.5717 65.8159 12.4067 65.0616 12.4067 64.0598V57.7465Z"
        fill="white"
      />
      <path
        d="M90.0185 53.7812L89.7352 54.0646C89.7352 54.0646 82.548 61.5661 82.0101 62.134V54.7818H78.6484V75.6726H82.0101V67.0952C82.0997 66.9912 86.4178 62.4173 86.9115 61.8948C86.9414 62.6564 87.404 75.6726 87.404 75.6726H90.841L90.0185 53.7812Z"
        fill="white"
      />
      <path
        d="M73.6257 54.0657L73.6102 54.0957L73.5803 54.11L73.5504 54.1554L73.505 54.1996L73.4452 54.2595L73.3854 54.3192L73.3101 54.3945L73.236 54.4698L73.1463 54.5595L73.0567 54.6647L72.9515 54.7687L72.8475 54.8727L72.7423 54.9923L72.6227 55.1118L72.4888 55.2457L72.2198 55.5302L71.9365 55.8291L71.6377 56.1435L71.3244 56.4722L70.9957 56.8154L70.6514 57.1584L70.3083 57.5171L69.964 57.8912L69.2623 58.6229L68.9192 58.9815L68.5761 59.3258L68.2473 59.6689L67.9341 60.0132L67.6209 60.3276L67.3364 60.6265L67.0674 60.9098L66.9335 61.0437L66.814 61.1788L66.6944 61.2984L66.5892 61.4179L66.4852 61.5231L66.3955 61.6283L66.3059 61.7179L66.2162 61.8076L66.1421 61.8829L66.0823 61.9427L66.0226 62.0025L65.9771 62.0622L65.9317 62.0921L65.9018 62.1375V54.7855H62.5234V75.6762H65.9006V67.0987C65.9903 66.9947 70.3095 62.4208 70.802 61.8984C70.8319 62.6599 71.2957 75.6762 71.2957 75.6762H74.7172L73.8947 53.7812L73.6257 54.0657Z"
        fill="white"
      />
      <path
        d="M54.0801 70.4863L53.8709 70.2329L53.6916 69.9795L53.5123 69.695L53.3628 69.4116L53.2134 69.1128L53.0783 68.8139L52.9432 68.5007L52.8392 68.1863L52.7495 67.8432L52.6599 67.5145L52.5846 67.1558L52.5248 66.7971L52.4794 66.423L52.4495 66.0488L52.4339 65.6603L52.4184 65.2717C52.4184 63.0757 52.9564 61.3267 54.0024 60.0416C55.1536 58.6369 56.8273 57.9352 59.009 57.9352H59.1728V54.2891H59.009C55.6019 54.2891 52.9863 55.335 51.2086 57.4415C49.5947 59.3399 48.7734 61.9842 48.7734 65.3016C48.7734 68.4995 49.67 71.1439 51.4178 73.1319C53.2708 75.224 55.8267 76.2999 59.0544 76.2999H59.2182V72.6394H59.0544C56.9349 72.6382 55.2612 71.9209 54.0801 70.4863Z"
        fill="white"
      />
      <path
        d="M27.0505 54.2727C25.243 54.2727 23.8001 55.296 22.754 57.2985C21.7379 59.271 21.2227 61.8938 21.2227 65.106C21.2227 68.4234 21.708 71.1061 22.6799 73.063C23.6662 75.0654 25.1378 76.0887 27.0505 76.0887C29.0087 76.0887 30.5544 75.0057 31.6459 72.9136C32.662 70.9554 33.1773 68.311 33.1773 65.0677C33.1773 61.8699 32.6537 59.2542 31.6076 57.2972L31.4953 57.1107L31.3829 56.9243L31.3076 56.7378L31.1582 56.5884L31.0828 56.4389L30.9334 56.2895L30.821 56.1401L30.7087 55.9906L30.5963 55.8412L30.4469 55.6918L30.3345 55.5794L30.185 55.4669L30.0727 55.3546L29.9232 55.2422L29.8109 55.1298L29.6614 55.0175L29.512 54.9422L29.3626 54.868L29.2131 54.7939L29.0637 54.7198L28.9143 54.6445L28.7648 54.5692L28.6154 54.5321L28.4289 54.4568L28.2795 54.4197L28.093 54.3827L27.9436 54.3456H27.7941L27.6076 54.3086L27.4211 54.2715H27.2346H27.0505V54.2727ZM27.0505 57.6344C28.0069 57.6344 28.7098 58.3146 29.1426 59.6894C29.561 60.9291 29.7403 62.7378 29.7403 65.069C29.7403 67.3248 29.5311 69.2005 29.0685 70.635L28.9932 70.7845L28.9561 70.8968L28.9191 71.0092L28.882 71.1216L28.8449 71.2339L28.7708 71.3463L28.7338 71.4587L28.6584 71.534L28.6214 71.6464L28.5461 71.7217L28.509 71.8341L28.4719 71.9094L28.3978 71.9835L28.3225 72.0577L28.2855 72.1317L28.2113 72.1688L28.1743 72.2429L28.099 72.317L28.0248 72.3541L27.9495 72.4282L27.8742 72.4653L27.7989 72.5023L27.7618 72.5394L27.6865 72.5764H27.6112L27.5359 72.6135L27.4618 72.6506H27.3865L27.3112 72.6876H27.2358H27.1605H27.0481C26.2269 72.6876 25.6064 71.9859 25.1426 70.5956C24.6644 69.1455 24.4325 67.2853 24.4325 65.1036C24.4325 62.8777 24.6644 61.039 25.1426 59.6499C25.5789 58.3217 26.2137 57.6344 27.0505 57.6344Z"
        fill="white"
      />
      <path
        d="M41.1247 70.4863L41.035 70.3668L40.9298 70.2329L40.7349 69.9795L40.5712 69.695L40.4062 69.4116L40.2568 69.1128L40.1229 68.8139L40.0033 68.5007L39.8838 68.1863L39.7941 67.8432L39.7045 67.5145L39.6447 67.1558L39.5849 66.7971L39.5407 66.423L39.5108 66.0488L39.4809 65.6603V65.2717C39.4809 63.0757 40.0033 61.3267 41.0649 60.0416C42.2006 58.6369 43.8742 57.9352 46.056 57.9352H46.2353V54.2891H46.056C42.6632 54.2891 40.0332 55.335 38.2711 57.4415C36.6417 59.3399 35.8359 61.9842 35.8359 65.3016C35.8359 68.4995 36.717 71.1439 38.4803 73.1319C40.3177 75.224 42.888 76.2999 46.1169 76.2999H46.2807V72.6394H46.1169C43.9782 72.6382 42.3046 71.9209 41.1247 70.4863Z"
        fill="white"
      />
      <path
        d="M9.19141 24.1484V45.1432H13.0623V27.6296H17.8442V45.1432H21.6995V24.1484H9.19141Z"
        fill="white"
      />
      <path
        d="M33.5516 23.5989C31.5038 23.5989 29.86 24.6294 28.6956 26.6629C27.5444 28.6509 26.9766 31.2809 26.9766 34.5075C26.9766 37.8393 27.5145 40.5673 28.6203 42.5398C29.7405 44.5578 31.3998 45.5655 33.5516 45.5655C35.7477 45.5655 37.4811 44.5123 38.7065 42.3904C39.8577 40.4179 40.4626 37.7508 40.4626 34.5075C40.4626 31.2798 39.835 28.6342 38.6694 26.6629L38.557 26.4764L38.4446 26.2899L38.3323 26.1034L38.1828 25.9539L38.0705 25.7674L37.921 25.618L37.8087 25.4686L37.6592 25.3191L37.5098 25.1697L37.3974 25.0573L37.248 24.9079L37.0986 24.7955L36.9491 24.6832L36.7997 24.5708L36.6132 24.4584L36.4638 24.3831L36.3143 24.2707L36.1649 24.1954L35.9784 24.1201L35.829 24.046L35.6425 23.9707L35.456 23.8954L35.3066 23.8583L35.1201 23.783L34.9336 23.7459L34.7471 23.7089L34.5606 23.6718L34.3741 23.6347H34.1493H33.9629L33.7764 23.5977H33.5516V23.5989ZM33.5899 27.1482C34.6359 27.1482 35.3759 27.8213 35.8684 29.1662C36.3167 30.3915 36.5403 32.1775 36.5403 34.5087C36.5403 36.7346 36.2785 38.596 35.756 40.0006C35.248 41.3754 34.5462 42.0174 33.5899 42.0174H33.4775H33.4022H33.3269H33.2527L33.1774 41.9803L33.1021 41.9433H33.0268L32.9515 41.9062L32.8774 41.8691L32.8021 41.8321L32.7267 41.795L32.6514 41.758L32.5761 41.6826L32.502 41.6456L32.4267 41.5715L32.3514 41.5344L32.3143 41.4591L32.239 41.385L32.1637 41.3097L32.1266 41.2343L32.0513 41.159L31.976 41.0467L31.9389 40.9714L31.8636 40.8961L31.8266 40.7837L31.7524 40.6712L31.7154 40.5959L31.6783 40.4465L31.603 40.3341L31.5659 40.2218L31.5289 40.1094L31.4536 39.997C30.9312 38.547 30.6693 36.7095 30.6693 34.5422C30.6693 32.3162 30.9312 30.5003 31.4536 29.1255C31.9533 27.7985 32.6478 27.1482 33.5899 27.1482Z"
        fill="white"
      />
      <path
        d="M61.5078 24.1484V27.6296H64.72V45.1432H68.5909V27.6296H71.8486V24.1484H61.5078Z"
        fill="white"
      />
      <path
        d="M53.0337 31.4544H50.9273C50.0606 31.4544 49.403 31.2607 48.999 30.8722C48.7001 30.6032 48.565 30.2291 48.565 29.7509V24.1465H44.6953V30.1393C44.6953 31.5141 45.2476 32.6941 46.3235 33.6206C47.3839 34.5327 48.7001 34.9953 50.2088 34.9953H53.0325V45.1412H56.9034V24.1465H53.0325V31.4544H53.0337Z"
        fill="white"
      />
      <path
        d="M76.8859 24.1606L76.1758 45.1565H80.024C80.024 45.1565 80.3826 35.3466 80.397 34.8827H85.2159C85.2613 35.3167 86.336 45.1565 86.336 45.1565H90.2213L88.4281 29.802V29.6155V29.429V29.2425L88.391 29.056V28.8695L88.354 28.7201V28.5336L88.3169 28.3841L88.2798 28.1976L88.2428 28.0482L88.2057 27.8988L88.1687 27.7493L88.1316 27.5999L88.0563 27.4505L88.0192 27.301L87.9822 27.1516L87.9069 27.0022L87.8316 26.8898L87.7562 26.7404L87.7192 26.628L87.6439 26.4786L87.5685 26.3662L87.4562 26.2538L87.3809 26.1044L87.3055 26.0291L87.1932 25.8797L87.1179 25.8044L87.0055 25.692L86.8931 25.5796L86.7807 25.5043L86.7054 25.3919L86.556 25.2795C85.5853 24.5168 84.2691 24.1582 82.5966 24.1582H76.8859V24.1606ZM80.5847 27.6346H81.9666C82.9672 27.6346 83.6403 27.9561 84.0587 28.5682C84.403 29.0763 84.6337 30.047 84.7688 31.4075H80.4723V31.3705V31.3334V31.2963V31.2593V31.2222V31.1851V31.1481V31.0357V30.9233V30.811L80.5093 30.6986V30.5492V30.4368V30.2874V30.1379V29.9885V29.8391V29.5031V29.2043L80.5464 29.0548V28.9054V28.756V28.6065V28.4571V28.3447V28.1953V28.0829V27.9705L80.5835 27.8952V27.8581V27.8211V27.7841V27.747V27.7099V27.6729V27.6346H80.5847Z"
        fill="white"
      />
    </svg>
  );
};

//Иконка Оригинал забрал...
interface OriginalDocumentIconProps {
  w?: number;
  h?: number;
}
export const OriginalDocumentIcon: React.FC<OriginalDocumentIconProps> = ({
  w = 40,
  h = 40
}) => {
  return (
    <svg
      width={w ? w : '50'}
      height={h ? h : '50'}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_8468_52311)">
        <path
          d="M12.6533 23.4117C12.5739 23.041 12.2416 22.7793 11.8622 22.7793H6.38274H1.10037C0.526545 22.7793 0.136342 23.3578 0.346881 23.892C0.790912 25.0155 1.88611 25.81 3.16702 25.81H3.35135H10.4871H15.6181C14.161 25.81 12.9439 24.7821 12.6533 23.4117Z"
          fill="#328777"
        />
        <path
          d="M25.9018 1.85724C25.4033 0.866953 24.3773 0.1875 23.1933 0.1875L9.44323 0.18882H9.44861C7.78761 0.201617 6.4381 1.59551 6.4381 3.28277V4.98079V20.2325L6.38295 22.7801C6.38295 24.4539 5.02602 25.8108 3.35156 25.8108H10.4873H15.6183H15.6439H20.3571C22.0362 25.8108 23.3979 24.4499 23.3979 22.77V3.21889H25.0555C25.7551 3.21889 26.2166 2.48154 25.9018 1.85724Z"
          fill="#4BCDB2"
        />
        <path
          d="M25.8961 1.85724C25.3975 0.866953 24.3716 0.1875 23.1876 0.1875L9.4375 0.18882H9.44288C9.51083 0.1875 9.57877 0.18948 9.64809 0.193543C10.0383 0.216395 10.4089 0.313945 10.7453 0.471367C11.6212 0.88041 12.2684 1.69641 12.446 2.67527C12.5032 2.99012 12.7763 3.21884 13.0958 3.21884H23.3921H25.0498C25.7494 3.21889 26.2109 2.48154 25.8961 1.85724Z"
          fill="#57EECF"
        />
        <path
          d="M20.5672 8.6517H9.75456C9.47593 8.6517 9.25 8.42578 9.25 8.14714C9.25 7.8685 9.47593 7.64258 9.75456 7.64258H20.5672C20.8459 7.64258 21.0717 7.8685 21.0717 8.14714C21.0717 8.42578 20.8459 8.6517 20.5672 8.6517Z"
          fill="#D3FDF9"
        />
        <path
          d="M20.5672 11.097H9.75456C9.47593 11.097 9.25 10.8711 9.25 10.5925C9.25 10.3138 9.47593 10.0879 9.75456 10.0879H20.5672C20.8459 10.0879 21.0717 10.3138 21.0717 10.5925C21.0717 10.8711 20.8459 11.097 20.5672 11.097Z"
          fill="#D3FDF9"
        />
        <path
          d="M19.3572 13.5423H9.75456C9.47593 13.5423 9.25 13.3164 9.25 13.0378C9.25 12.7591 9.47593 12.5332 9.75456 12.5332H19.3572C19.6359 12.5332 19.8618 12.7591 19.8618 13.0378C19.8618 13.3165 19.6359 13.5423 19.3572 13.5423Z"
          fill="#D3FDF9"
        />
        <path
          d="M17.8945 15.9876H9.75456C9.47593 15.9876 9.25 15.7617 9.25 15.4831C9.25 15.2044 9.47593 14.9785 9.75456 14.9785H17.8945C18.1732 14.9785 18.3991 15.2044 18.3991 15.4831C18.3991 15.7617 18.1731 15.9876 17.8945 15.9876Z"
          fill="#D3FDF9"
        />
        <path
          d="M20.5672 18.4349H9.75456C9.47593 18.4349 9.25 18.209 9.25 17.9303C9.25 17.6517 9.47593 17.4258 9.75456 17.4258H20.5672C20.8459 17.4258 21.0717 17.6517 21.0717 17.9303C21.0717 18.209 20.8459 18.4349 20.5672 18.4349Z"
          fill="#D3FDF9"
        />
        <path
          d="M15.6408 20.8802H9.75456C9.47593 20.8802 9.25 20.6543 9.25 20.3757C9.25 20.097 9.47593 19.8711 9.75456 19.8711H15.6408C15.9196 19.8711 16.1454 20.097 16.1454 20.3757C16.1454 20.6543 15.9195 20.8802 15.6408 20.8802Z"
          fill="#D3FDF9"
        />
        <path
          d="M4.86459 11.5729C7.55123 11.5729 9.72918 9.39498 9.72918 6.70834C9.72918 4.0217 7.55123 1.84375 4.86459 1.84375C2.17795 1.84375 0 4.0217 0 6.70834C0 9.39498 2.17795 11.5729 4.86459 11.5729Z"
          fill="#FFE477"
        />
        <path
          d="M3.70326 8.84427C3.69386 8.84427 3.68437 8.84402 3.67492 8.84346C3.53527 8.83559 3.40517 8.77013 3.31559 8.66268L2.23416 7.36491C2.05576 7.15087 2.08466 6.83272 2.29875 6.65428C2.51269 6.47578 2.83094 6.50478 3.00938 6.71887L3.74475 7.6013L6.76329 4.71047C6.96448 4.51776 7.28384 4.52461 7.47666 4.72586C7.66938 4.92716 7.66252 5.24647 7.46127 5.43923L4.05228 8.70411C3.95803 8.79435 3.8329 8.84427 3.70326 8.84427Z"
          fill="#CCA400"
        />
      </g>
      <defs>
        <clipPath id="clip0_8468_52311">
          <rect width="26" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

// Иконка нарочно
interface OnHandsIconProps {
  w?: number;
  h?: number;
}
export const OnHandsIcon: React.FC<OnHandsIconProps> = ({ w = 40, h = 40 }) => {
  return (
    <svg
      width={w ? w : '50'}
      height={h ? h : '50'}
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M79.4715 66.0885C76.9421 70.8532 74.4127 75.6375 71.8833 80.4414C70.9715 80.0002 70.0597 79.5591 69.1774 79.0885C68.1602 78.5846 67.2622 77.8695 66.5435 76.9909C65.8247 76.1123 65.3018 75.0904 65.0094 73.9936C64.7171 72.8967 64.6622 71.7501 64.8484 70.6304C65.0346 69.5106 65.4576 68.4435 66.0892 67.5002C66.3833 67.0591 68.0303 64.6767 68.3244 64.2355H80.2656L80.1774 64.4414C79.9724 65.0029 79.7368 65.5528 79.4715 66.0885Z"
        fill="#E5B6A9"
      />
      <path
        d="M16.9412 67.1758L111.059 67.1758C112.683 67.1758 114 65.859 114 64.2346L114 5.41108C114 3.78671 112.683 2.4699 111.059 2.4699L16.9412 2.4699C15.3168 2.4699 14 3.78671 14 5.41108L14 64.2346C14 65.859 15.3168 67.1758 16.9412 67.1758Z"
        fill="#FF9811"
      />
      <path
        d="M92.5275 48.1758L92.4098 48.2934C93.2082 49.0262 93.8038 49.9528 94.1387 50.9834C94.4737 52.014 94.5367 53.1137 94.3216 54.1758C93.0275 58.4699 91.7333 62.7934 90.4392 67.0875L90.7039 67.1758H111.057C111.809 67.1716 112.53 66.8776 113.07 66.3549C106.23 60.279 99.3824 54.2193 92.5275 48.1758Z"
        fill="#FFB655"
      />
      <path
        d="M91.0018 47.4111C91.5129 47.6348 91.9886 47.932 92.4136 48.2934L92.5312 48.1758C87.7665 43.9699 83.0312 39.764 78.2665 35.5581C73.5018 31.3228 68.7665 27.117 64.0018 22.9111C58.7665 27.5581 53.5116 32.2052 48.2371 36.8523C37.1345 46.696 26.0318 56.5301 14.929 66.3545C15.4695 66.8775 16.1909 67.1717 16.943 67.1758L77.3254 67.1758L83.1489 51.264C83.4025 50.4892 83.8087 49.7731 84.3435 49.1577C84.8783 48.5424 85.5309 48.0404 86.2628 47.6813C86.9947 47.3222 87.791 47.1133 88.605 47.0669C89.4189 47.0205 90.2339 47.1375 91.0018 47.4111Z"
        fill="#FFB655"
      />
      <path
        d="M14.8403 3.3716C25.9722 14.5584 37.1042 25.7191 48.2362 36.8535C53.5009 32.2065 58.7558 27.5594 64.0009 22.9123C68.7656 27.1182 73.5009 31.3241 78.2656 35.5594C89.8594 24.8267 101.535 14.0928 113.133 3.33249C112.861 3.0597 112.538 2.84321 112.182 2.69541C111.826 2.54762 111.445 2.47141 111.06 2.47116L59.5009 2.47116C59.5009 2.50057 59.4715 2.50058 59.4715 2.52999L53.6774 18.3829C53.4227 19.1564 53.0154 19.8709 52.4797 20.4842C51.944 21.0976 51.2908 21.5972 50.5587 21.9537C49.8265 22.3102 49.0303 22.5162 48.2172 22.5596C47.404 22.603 46.5904 22.483 45.8244 22.2065C44.5869 21.631 43.5845 20.648 42.9849 19.422C42.3853 18.196 42.2248 16.8013 42.5303 15.4712C43.795 11.177 45.0891 6.85337 46.4127 2.52999L46.2362 2.47116L16.9421 2.47116C16.5492 2.47231 16.1606 2.55264 15.7995 2.70735C15.4384 2.86206 15.1122 3.08797 14.8403 3.3716Z"
        fill="#FFA733"
      />
      <path
        d="M58.1166 126V119.794C58.0729 118.89 58.3885 118.005 58.9946 117.333C59.6007 116.661 60.4481 116.256 61.3519 116.206H98.999C99.9028 116.256 100.75 116.661 101.356 117.333C101.962 118.005 102.278 118.89 102.234 119.794V126H58.1166Z"
        fill="#66A9FF"
      />
      <path
        d="M77.326 67.1757L83.1495 51.2639C83.4031 50.4891 83.8093 49.773 84.3441 49.1577C84.8789 48.5423 85.5315 48.0403 86.2634 47.6812C86.9953 47.3222 87.7917 47.1132 88.6056 47.0668C89.4195 47.0204 90.2345 47.1374 91.0024 47.411C91.5135 47.6348 91.9891 47.932 92.4142 48.2933C93.2126 49.0261 93.8081 49.9527 94.1431 50.9833C94.478 52.0139 94.541 53.1135 94.326 54.1757C93.0319 58.4698 91.7377 62.7933 90.4436 67.0874L90.7083 67.1757H105.179C105.973 71.7933 106.767 78.3815 107.532 82.9992C107.914 85.2075 107.53 87.4801 106.444 89.4404L97.6201 105.146C96.7951 106.61 96.3596 108.26 96.3554 109.94V116.205H64.0024V95.9698C63.9991 93.8168 64.5243 91.696 65.5319 89.7933C66.6789 87.6463 67.7966 85.4992 68.9436 83.3815C71.473 78.5874 74.0024 73.8031 76.5319 69.0286C76.7971 68.4929 77.0328 67.9431 77.2377 67.3815L77.326 67.1757Z"
        fill="#EFC5B8"
      />
      <path
        d="M77.326 67.1757L83.1495 51.2639C83.4031 50.4891 83.8093 49.773 84.3441 49.1577C84.8789 48.5423 85.5315 48.0403 86.2634 47.6812C86.9953 47.3222 87.7917 47.1132 88.6056 47.0668C89.4195 47.0204 90.2345 47.1374 91.0024 47.411C91.5135 47.6348 91.9891 47.932 92.4142 48.2933C93.2126 49.0261 93.8081 49.9527 94.1431 50.9833C94.478 52.0139 94.541 53.1135 94.326 54.1757C93.0319 58.4698 91.7377 62.7933 90.4436 67.0874L90.7083 67.1757H105.179C105.973 71.7933 106.767 78.3815 107.532 82.9992C107.914 85.2075 107.53 87.4801 106.444 89.4404L97.6201 105.146C96.7951 106.61 96.3596 108.26 96.3554 109.94V116.205H64.0024V95.9698C63.9991 93.8168 64.5243 91.696 65.5319 89.7933C66.6789 87.6463 67.7966 85.4992 68.9436 83.3815C71.473 78.5874 74.0024 73.8031 76.5319 69.0286C76.7971 68.4929 77.0328 67.9431 77.2377 67.3815L77.326 67.1757Z"
        fill="#EFC5B8"
      />
      <path
        d="M90.4354 67.1761L88.9973 71.9757C88.59 73.3442 88.382 74.7642 88.3797 76.1921V90.7228C88.3797 91.1128 88.5346 91.4868 88.8104 91.7626C89.0862 92.0384 89.4603 92.1934 89.8503 92.1934C90.2403 92.1934 90.6144 92.0384 90.8901 91.7626C91.1659 91.4868 91.3209 91.1128 91.3209 90.7228V76.1921C91.3218 75.0501 91.4882 73.9143 91.815 72.8201L93.5039 67.1761H90.4354Z"
        fill="#E5B6A9"
      />
      <rect
        x="39"
        y="23"
        width="20.5"
        height="22"
        transform="rotate(-90 39 23)"
        fill="#FFA733"
      />
    </svg>
  );
};

// Пустой шаблон для новых иконок
interface CourierIconProps {
  w?: number;
  h?: number;
}

export const CourierIcon: React.FC<CourierIconProps> = ({ w = 40, h = 40 }) => {
  return (
    <svg
      width={w ? w : '50'}
      height={h ? h : '50'}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M56.3156 9.26908V12.4483C55.7552 21.9503 48.0198 22.0316 48.0198 22.0316C45.9145 21.9105 43.9204 21.0469 42.3916 19.5945C40.8628 18.142 39.8984 16.1946 39.6698 14.0983L39.5469 13.0899L39.2948 11.0212L38.9302 8.03992C38.8552 7.36809 38.9133 6.68807 39.1012 6.0387C39.2891 5.38933 39.603 4.78335 40.0252 4.25537C40.4473 3.72739 40.9694 3.28776 41.5615 2.9616C42.1536 2.63544 42.8042 2.42915 43.4761 2.3545L50.2823 1.59408C51.639 1.44314 53.0001 1.83725 54.0663 2.68972C55.1325 3.5422 55.8164 4.78324 55.9677 6.13992L56.2011 8.23783L56.3156 9.26908Z"
        fill="#FED9B9"
      />
      <path
        d="M63.5898 21.2793H92.1273V49.746H63.5898V21.2793Z"
        fill="#FCBD55"
      />
      <path
        d="M78.7872 47.2314H92.1206V21.2793H67.4414V35.8835C67.4414 38.8928 68.6367 41.7788 70.7644 43.9069C72.8921 46.035 75.778 47.2308 78.7872 47.2314Z"
        fill="#FCCA6E"
      />
      <path
        d="M64.8128 44.2518H64.7794C64.3541 44.2519 63.939 44.1217 63.5898 43.8789V45.6977C63.9732 45.8267 64.3749 45.8928 64.7794 45.8935H64.8753L72.8169 45.5227C72.1004 45.0804 71.4352 44.5598 70.8336 43.9706L64.8128 44.2518Z"
        fill="#FCAC44"
      />
      <path
        d="M83.0008 43.4434H82.9154C82.3133 43.4434 75.8695 43.7371 70.832 43.9704C71.4337 44.5589 72.0989 45.0788 72.8154 45.5204C77.5466 45.3017 82.1112 45.1038 82.8549 45.085L85.4654 45.5579L92.132 45.4996V43.8767L85.6112 43.9163L83.0008 43.4434Z"
        fill="#FCBD55"
      />
      <path
        d="M54.8568 64.1048L53.5026 67.3757C52.5686 66.988 51.6694 66.521 50.8151 65.9798C48.2429 64.2506 46.0054 62.0695 44.2109 59.5423L45.4818 53.7715C45.7943 56.0423 47.9818 59.6882 52.7526 63.0215C53.422 63.4417 54.1259 63.8041 54.8568 64.1048Z"
        fill="#40A6C2"
      />
      <path
        d="M74.1445 21.2793H81.4883V28.623H74.1445V21.2793Z"
        fill="#FF953F"
      />
      <path
        d="M78.4497 27.4835H81.4872V21.2793H75.9102V24.946C75.9102 25.2794 75.9759 25.6095 76.1035 25.9175C76.2312 26.2255 76.4183 26.5053 76.6541 26.741C76.89 26.9766 77.1699 27.1635 77.478 27.2909C77.7861 27.4183 78.1163 27.4837 78.4497 27.4835Z"
        fill="#F99E4D"
      />
      <path
        d="M85.3998 91.8133C85.3469 91.5053 85.2323 91.2112 85.0629 90.9486C84.8935 90.686 84.6728 90.4604 84.414 90.2852C84.1551 90.1101 83.8636 89.9891 83.5569 89.9295C83.2501 89.8699 82.9345 89.8728 82.6289 89.9383L81.4831 90.1466L77.0039 64.3341C76.9011 63.7594 76.6696 63.2155 76.3269 62.7429C75.9841 62.2703 75.539 61.8813 75.0248 61.6049L60.4623 53.7716L59.6498 41.4591L56.8164 38.9799L62.1289 33.2716C59.1706 29.7508 54.7331 25.4383 54.0248 24.7299C52.4974 23.2981 50.573 22.3613 48.5039 22.0424C45.3164 21.8341 41.7539 23.7924 41.7539 27.2716C41.7539 29.0424 42.6498 35.3549 43.5664 41.3966C43.5664 41.3966 45.3789 52.8966 45.4831 53.7716L41.3998 72.2508C41.313 72.7236 41.053 73.147 40.6706 73.4383L25.481 85.4174L25.4623 85.432L21.9623 87.7862C21.7571 87.9778 21.6274 88.2366 21.5968 88.5157C21.5662 88.7948 21.6368 89.0755 21.7956 89.307L28.3373 98.432L30.7956 96.7862C31.0491 96.604 31.2636 96.373 31.4265 96.1066C31.5894 95.8403 31.6973 95.544 31.7439 95.2353C31.7905 94.9267 31.7748 94.6118 31.6978 94.3092C31.6208 94.0067 31.4841 93.7226 31.2956 93.4737L30.6914 92.6612L48.7956 78.182C49.1048 77.9416 49.3366 77.6156 49.4623 77.2445L54.8581 64.0987C58.9681 65.5947 63.1895 66.765 67.4831 67.5987C67.7144 67.6401 67.9271 67.7527 68.0914 67.9208C68.2558 68.0888 68.3635 68.304 68.3998 68.5362L72.7748 92.0341L73.4998 95.932C73.5845 96.1968 73.7615 96.4224 73.9986 96.5677C74.2356 96.713 74.517 96.7684 74.7914 96.7237L85.8331 94.7237L85.3998 91.8133Z"
        fill="#F99E4D"
      />
      <path
        d="M50.2821 1.59402L43.4759 2.35235C42.1192 2.50363 40.8781 3.18757 40.0257 4.25375C39.1732 5.31993 38.7791 6.68105 38.93 8.03777L39.4175 12.0357L56.3154 9.26901L55.9675 6.14401C55.8931 5.47189 55.687 4.821 55.361 4.22855C55.035 3.6361 54.5954 3.11368 54.0675 2.69114C53.5395 2.26861 52.9334 1.95424 52.2839 1.76599C51.6344 1.57774 50.9542 1.5193 50.2821 1.59402Z"
        fill="#EB7729"
      />
      <path
        d="M25.4623 85.4388L21.9623 87.793C21.7571 87.9846 21.6274 88.2434 21.5968 88.5225C21.5662 88.8015 21.6368 89.0823 21.7956 89.3138L28.3373 98.4388L30.7956 96.793C31.0491 96.6108 31.2636 96.3798 31.4265 96.1134C31.5894 95.8471 31.6973 95.5508 31.7439 95.2421C31.7905 94.9334 31.7748 94.6185 31.6978 94.316C31.6208 94.0134 31.4841 93.7293 31.2956 93.4805L30.6914 92.668L25.481 85.418L25.4623 85.4388Z"
        fill="#323648"
      />
      <path
        d="M45.4826 53.7715L41.3992 72.2507C41.3124 72.7234 41.0524 73.1469 40.6701 73.4382L25.4805 85.4173L30.6888 92.6611L48.793 78.1819C49.1022 77.9414 49.334 77.6154 49.4596 77.2444L54.8555 64.0986C54.1246 63.7979 53.4207 63.4354 52.7513 63.0152C47.9826 59.6882 45.7951 56.0423 45.4826 53.7715Z"
        fill="#EB7729"
      />
      <path
        d="M47.9524 61.5271C47.8624 61.4311 47.7478 61.3615 47.621 61.3259C47.4943 61.2902 47.3602 61.2898 47.2333 61.3248C47.1064 61.3597 46.9914 61.4287 46.9008 61.5242C46.8102 61.6197 46.7473 61.7381 46.7191 61.8667L44.2795 72.9084C44.1927 73.3812 43.9327 73.8046 43.5504 74.0959L31.5962 83.5292C30.7242 84.2152 30.1508 85.2113 29.9955 86.3098C29.8402 87.4083 30.1151 88.5243 30.7629 89.4251L32.2212 91.4438L48.7941 78.1896C49.1033 77.9492 49.3352 77.6232 49.4608 77.2521L54.0129 66.1626C53.4448 65.8863 52.8932 65.5774 52.3608 65.2376C50.7791 64.1405 49.3033 62.8984 47.9524 61.5271Z"
        fill="#FF953F"
      />
      <path
        d="M81.2107 88.5965L77.0003 64.334C76.8975 63.7593 76.666 63.2154 76.3233 62.7428C75.9805 62.2702 75.5354 61.8812 75.0212 61.6048L60.4587 53.7715L59.6378 41.3361L56.9753 39.0173L61.9607 33.6402L61.8732 33.5423L62.1316 33.2652C59.1732 29.7444 54.7357 25.4319 54.0274 24.7236C52.5001 23.2918 50.5757 22.355 48.5066 22.0361C47.2566 21.9577 46.007 22.1956 44.8732 22.7278C44.4381 23.4508 44.2103 24.2797 44.2149 25.1236C44.2149 26.8944 45.1107 33.2069 46.0274 39.2486C46.0274 39.2486 47.8399 50.7486 47.9441 51.6236C48.2566 53.8944 50.4441 57.5402 55.2149 60.8736C55.8843 61.2938 56.5882 61.6562 57.3191 61.9569C61.4291 63.4529 65.6505 64.6232 69.9441 65.4569C70.1754 65.4983 70.3881 65.6109 70.5524 65.779C70.7167 65.947 70.8245 66.1622 70.8607 66.3944L74.3399 85.0653C74.4567 85.6921 74.6981 86.2892 75.0499 86.821C75.4016 87.3529 75.8565 87.8087 76.3877 88.1615C76.9188 88.5143 77.5154 88.7569 78.1421 88.8749C78.7687 88.993 79.4126 88.984 80.0357 88.8486L81.2107 88.5965Z"
        fill="#FCAC44"
      />
      <path
        d="M59.6495 41.4583L52.2578 35V35.2083C52.258 35.5219 52.3254 35.8319 52.4555 36.1172C52.5856 36.4026 52.7753 36.6567 53.012 36.8625L59.7307 42.6875L59.6495 41.4583Z"
        fill="#F99E4D"
      />
      <path
        d="M85.3982 91.8131C85.3453 91.5051 85.2307 91.211 85.0613 90.9484C84.8919 90.6858 84.6712 90.4602 84.4124 90.2851C84.1536 90.11 83.862 89.9889 83.5553 89.9293C83.2485 89.8697 82.9329 89.8727 82.6273 89.9381L81.4815 90.1465L72.7773 92.0402L73.5023 95.9381C73.5871 96.2029 73.7641 96.4285 74.0012 96.5738C74.2382 96.7191 74.5196 96.7745 74.794 96.7298L85.8357 94.7298L85.3982 91.8131Z"
        fill="#323648"
      />
      <path
        d="M63.751 9.10534L56.3115 10.3303L39.549 13.0887L39.2969 11.0199L56.2031 8.23867L63.4177 7.04909C63.6904 7.00406 63.9698 7.06919 64.1944 7.23016C64.4191 7.39113 64.5706 7.63474 64.6156 7.90742C64.6607 8.1801 64.5955 8.45949 64.4346 8.68415C64.2736 8.9088 64.03 9.06031 63.7573 9.10534H63.751Z"
        fill="#EB7729"
      />
      <path
        d="M32.207 59.6133H23.5195C23.1051 59.6133 22.7077 59.4487 22.4147 59.1556C22.1217 58.8626 21.957 58.4652 21.957 58.0508C21.957 57.6364 22.1217 57.239 22.4147 56.9459C22.7077 56.6529 23.1051 56.4883 23.5195 56.4883H32.207C32.6214 56.4883 33.0189 56.6529 33.3119 56.9459C33.6049 57.239 33.7695 57.6364 33.7695 58.0508C33.7695 58.4652 33.6049 58.8626 33.3119 59.1556C33.0189 59.4487 32.6214 59.6133 32.207 59.6133Z"
        fill="#585F76"
      />
      <path
        d="M28.5292 51.291H7.875C7.4606 51.291 7.06317 51.1264 6.77015 50.8334C6.47712 50.5403 6.3125 50.1429 6.3125 49.7285C6.3125 49.3141 6.47712 48.9167 6.77015 48.6237C7.06317 48.3306 7.4606 48.166 7.875 48.166H28.5292C28.9436 48.166 29.341 48.3306 29.634 48.6237C29.927 48.9167 30.0917 49.3141 30.0917 49.7285C30.0917 50.1429 29.927 50.5403 29.634 50.8334C29.341 51.1264 28.9436 51.291 28.5292 51.291Z"
        fill="#585F76"
      />
      <path
        d="M47.4768 42.9688H35.4727C35.0583 42.9688 34.6608 42.8041 34.3678 42.5111C34.0748 42.2181 33.9102 41.8207 33.9102 41.4062C33.9102 40.9918 34.0748 40.5944 34.3678 40.3014C34.6608 40.0084 35.0583 39.8438 35.4727 39.8438H47.4768C47.8912 39.8438 48.2887 40.0084 48.5817 40.3014C48.8747 40.5944 49.0393 40.9918 49.0393 41.4062C49.0393 41.8207 48.8747 42.2181 48.5817 42.5111C48.2887 42.8041 47.8912 42.9688 47.4768 42.9688Z"
        fill="#585F76"
      />
      <path
        d="M35.4714 34.6465H18.3047C17.8903 34.6465 17.4929 34.4819 17.1998 34.1888C16.9068 33.8958 16.7422 33.4984 16.7422 33.084C16.7422 32.6696 16.9068 32.2722 17.1998 31.9791C17.4929 31.6861 17.8903 31.5215 18.3047 31.5215H35.4714C35.8858 31.5215 36.2832 31.6861 36.5762 31.9791C36.8692 32.2722 37.0339 32.6696 37.0339 33.084C37.0339 33.4984 36.8692 33.8958 36.5762 34.1888C36.2832 34.4819 35.8858 34.6465 35.4714 34.6465Z"
        fill="#585F76"
      />
      <path
        d="M86.4872 37.0326L84.131 38.4201L67.0227 37.8201C66.4381 37.7667 65.8895 37.5145 65.4685 37.1055L61.8768 33.543L56.8164 38.9596L62.8414 44.3117C63.3909 44.8051 64.1072 45.0716 64.8456 45.0576C64.8456 45.0576 82.0518 44.2451 82.9331 44.2492L85.5435 44.7221L92.1352 44.6659V36.8326L86.4872 37.0326Z"
        fill="#FED9B9"
      />
    </svg>
  );
};

// С почты сотрудника ССС (собачка)
interface EmailEmployeeIconProps {
  w?: number;
  h?: number;
}

export const EmailEmployeeIcon: React.FC<EmailEmployeeIconProps> = ({
  w = 30,
  h = 30
}) => {
  return (
    <svg
      width={w ? w : '50'}
      height={h ? h : '50'}
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M125.393 55.1992C123.158 38.9038 114.54 24.1639 101.437 14.2222C88.3331 4.28055 71.8169 -0.0485858 55.5215 2.18719C39.226 4.42296 24.4862 13.0405 14.5445 26.144C4.60281 39.2476 0.27368 55.7638 2.50945 72.0592C4.35144 85.5465 10.5494 98.0627 20.1601 107.703C29.7708 117.343 42.2679 123.58 55.7495 125.463C58.5081 125.825 61.2873 126.006 64.0695 126.007C75.3101 126.026 86.3402 122.958 95.9575 117.139C96.6325 116.733 97.2208 116.197 97.6888 115.563C98.1568 114.929 98.4954 114.209 98.6852 113.445C98.875 112.68 98.9123 111.885 98.795 111.106C98.6777 110.327 98.408 109.578 98.0015 108.903C97.5949 108.228 97.0593 107.64 96.4254 107.172C95.7915 106.704 95.0716 106.365 94.3068 106.175C92.7622 105.792 91.1287 106.038 89.7655 106.859C82.9201 110.968 75.1903 113.378 67.2227 113.887C59.2551 114.396 51.2814 112.99 43.9686 109.786C36.6558 106.582 30.2166 101.674 25.1895 95.4714C20.1625 89.2689 16.6938 81.9528 15.0737 74.135C13.4536 66.3173 13.7292 58.2253 15.8773 50.5358C18.0254 42.8464 21.9837 35.7832 27.421 29.937C32.8583 24.0909 39.6165 19.6317 47.1303 16.9327C54.6441 14.2336 62.695 13.3732 70.6095 14.4232C77.9607 15.4006 85.0025 18.0011 91.2247 22.0361C97.4468 26.0712 102.693 31.4398 106.584 37.753C110.475 44.0663 112.913 51.166 113.722 58.5378C114.53 65.9096 113.688 73.3689 111.257 80.3752C110.627 82.06 109.487 83.5066 107.997 84.5144C106.507 85.5222 104.74 86.0411 102.941 85.9992C100.571 85.996 98.2993 85.0531 96.6234 83.3772C94.9475 81.7013 94.0046 79.4292 94.0015 77.0592V39.9992C94.0015 38.4079 93.3693 36.8818 92.2441 35.7565C91.1189 34.6313 89.5928 33.9992 88.0015 33.9992C86.4102 33.9992 84.884 34.6313 83.7588 35.7565C82.6336 36.8818 82.0015 38.4079 82.0015 39.9992V40.0552C77.4529 36.6222 72.0206 34.5557 66.3403 34.0976C60.6601 33.6395 54.9668 34.8087 49.9269 37.4685C44.8869 40.1282 40.7088 44.1685 37.8815 49.1163C35.0541 54.0642 33.6945 59.715 33.9618 65.4074C34.229 71.0999 36.1121 76.5984 39.3906 81.2596C42.6691 85.9208 47.2074 89.5518 52.4743 91.7277C57.7413 93.9035 63.519 94.5342 69.1314 93.5459C74.7438 92.5577 79.9585 89.9913 84.1655 86.1472C85.8652 89.6875 88.5281 92.6771 91.849 94.7734C95.1699 96.8696 99.0143 97.9876 102.941 97.9992C107.234 98.0405 111.434 96.744 114.956 94.2896C118.479 91.8352 121.149 88.3448 122.597 84.3032C125.831 74.9623 126.79 64.9848 125.393 55.1992V55.1992ZM64.0015 81.9992C60.4414 81.9992 56.9613 80.9435 54.0012 78.9656C51.0411 76.9878 48.734 74.1766 47.3716 70.8875C46.0092 67.5984 45.6528 63.9792 46.3473 60.4876C47.0419 56.9959 48.7562 53.7886 51.2735 51.2713C53.7909 48.7539 56.9982 47.0396 60.4898 46.3451C63.9815 45.6505 67.6007 46.007 70.8898 47.3694C74.1788 48.7317 76.99 51.0388 78.9679 53.9989C80.9458 56.959 82.0015 60.4391 82.0015 63.9992C81.9962 68.7715 80.098 73.3468 76.7235 76.7213C73.349 80.0958 68.7737 81.9939 64.0015 81.9992V81.9992Z"
        fill="url(#paint0_linear_9375_54357)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9375_54357"
          x1="-8.29054"
          y1="125.455"
          x2="107.341"
          y2="26.3392"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A1E2" />
          <stop offset="1" stopColor="#00E0A5" />
        </linearGradient>
      </defs>
    </svg>
  );
};

// Лого для входящей корреспонденции (письмо, лоток и синяя стрелка вниз)
interface IncomingCorrIconProps {
  w?: number;
  h?: number;
}

export const IncomingCorrIcon: React.FC<IncomingCorrIconProps> = ({
  w = 40,
  h = 40
}) => {
  return (
    <svg
      width={w ? w : '50'}
      height={h ? h : '50'}
      viewBox="0 0 256 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_8373_50721)">
        <path
          d="M224.402 202.756H31.1953V83.0801C31.1953 80.207 33.5254 77.877 36.3984 77.877H219.199C222.072 77.877 224.402 80.2051 224.402 83.0801V202.756Z"
          fill="#FDC26B"
        />
        <path
          d="M31.1953 83.0801V112.527C31.1953 114.404 32.2051 116.137 33.8398 117.059L125.238 168.703C126.828 169.602 128.77 169.602 130.359 168.703L205.889 126.025C209.357 124.066 213.652 126.572 213.652 130.555V202.756H224.402V83.0801C224.402 80.207 222.072 77.877 219.199 77.877H36.3984C33.5254 77.877 31.1953 80.207 31.1953 83.0801V83.0801Z"
          fill="#FCB54C"
        />
        <path
          d="M31.1953 202.756L127.799 132.463L224.402 202.756H31.1953Z"
          fill="#FBA72D"
        />
        <path
          d="M224.402 202.756L127.799 132.463L31.1953 202.756H46.1172L127.799 143.32L209.48 202.756H224.402Z"
          fill="#FA9A0F"
        />
        <path
          d="M156.949 153.676L127.795 132.463L98.6406 153.676L125.234 168.703C126.824 169.602 128.766 169.602 130.355 168.703L156.949 153.676Z"
          fill="#FA9A0F"
        />
        <path
          d="M224.402 83.0801V103.508C224.402 105.383 223.393 107.115 221.76 108.037L130.359 159.682C128.77 160.58 126.828 160.58 125.24 159.682L33.8398 108.037C32.2051 107.115 31.1953 105.383 31.1953 103.508V83.0801C31.1953 80.207 33.5254 77.877 36.3984 77.877H219.199C222.072 77.877 224.402 80.207 224.402 83.0801V83.0801Z"
          fill="#FECF8A"
        />
        <path
          d="M245.391 182.113H10.2031C7.33008 182.113 5 184.443 5 187.318V250.797C5 253.67 7.33008 256 10.2031 256H245.391C248.264 256 250.594 253.67 250.594 250.797V187.316C250.594 184.443 248.264 182.113 245.391 182.113Z"
          fill="#B4D2D7"
        />
        <path
          d="M238.627 182.113V233.627C238.627 239.373 233.967 244.033 228.221 244.033H5V250.797C5 253.67 7.33008 256 10.2031 256H245.391C248.264 256 250.594 253.67 250.594 250.797V187.316C250.594 184.443 248.266 182.113 245.391 182.113H238.627Z"
          fill="#9BB9C3"
        />
        <path
          d="M130.183 116.855L171.845 67.5762C173.56 65.5469 172.119 62.4395 169.46 62.4395H148.611V5.20312C148.611 2.33008 146.283 0 143.408 0H112.189C109.316 0 106.986 2.33008 106.986 5.20312V62.4395H86.1361C83.4779 62.4395 82.0365 65.5488 83.7514 67.5762L125.413 116.855C126.662 118.33 128.935 118.33 130.183 116.855Z"
          fill="#2A7BE4"
        />
        <path
          d="M148.607 62.4395V5.20312C148.607 2.33008 146.279 0 143.404 0H139.242V56.1953C139.242 59.6426 142.037 62.4395 145.486 62.4395H148.607Z"
          fill="#334FDF"
        />
        <path
          d="M166.818 62.4395L123.109 114.137C123.475 114.568 124.445 115.715 125.408 116.855C126.656 118.33 128.93 118.33 130.178 116.855L171.84 67.5762C173.555 65.5469 172.113 62.4395 169.455 62.4395H166.818Z"
          fill="#334FDF"
        />
        <path
          d="M127.794 227.383H164.389C166.491 227.383 168.385 226.119 169.192 224.18L176.464 206.729C177.321 204.672 175.809 202.406 173.583 202.406H81.485C79.2565 202.406 77.7468 204.674 78.6022 206.729L85.8737 224.18C86.6823 226.119 88.5768 227.383 90.6764 227.383H127.794Z"
          fill="#87A0AF"
        />
        <path
          d="M89.9694 213.094C89.3991 211.723 90.4069 210.211 91.8913 210.211H175.012L176.464 206.729C177.321 204.672 175.811 202.406 173.583 202.406H81.485C79.2565 202.406 77.7468 204.674 78.6022 206.729L85.8737 224.18C86.6823 226.119 88.5768 227.383 90.6764 227.383H95.9225L89.9694 213.094Z"
          fill="#738C96"
        />
      </g>
      <defs>
        <clipPath id="clip0_8373_50721">
          <rect width="256" height="256" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

// Лого для исходящей корреспонденции (письмо, лоток и зеленая стрелка вверх)
interface OutgoingCorrIconProps {
  w?: number;
  h?: number;
}

export const OutgoingCorrIcon: React.FC<OutgoingCorrIconProps> = ({
  w = 40,
  h = 40
}) => {
  return (
    <svg
      width={w ? w : '50'}
      height={h ? h : '50'}
      viewBox="0 0 256 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_8384_50736)">
        <path
          d="M225.876 202.396H31.3672V81.916C31.3672 79.0215 33.7129 76.6758 36.6055 76.6758H220.638C223.533 76.6758 225.876 79.0215 225.876 81.916V202.396Z"
          fill="#FDC26B"
        />
        <path
          d="M31.3672 81.916V114.619L126.047 168.115C127.644 169.019 129.599 169.019 131.199 168.115L208.81 124.262C212.302 122.289 216.626 124.812 216.626 128.822V202.396H225.876V81.916C225.876 79.0215 223.533 76.6758 220.638 76.6758H36.6055C33.7129 76.6758 31.3672 79.0215 31.3672 81.916V81.916Z"
          fill="#FCB54C"
        />
        <path
          d="M31.3672 202.396L128.623 131.629L225.876 202.396H31.3672Z"
          fill="#FBA72D"
        />
        <path
          d="M225.876 202.396L128.623 131.629L31.3672 202.396H46.3906L128.623 142.561L210.853 202.396H225.876Z"
          fill="#FA9A0F"
        />
        <path
          d="M157.977 152.986L128.625 131.629L99.2734 152.986L126.049 168.115C127.646 169.02 129.602 169.02 131.201 168.115L157.977 152.986Z"
          fill="#FA9A0F"
        />
        <path
          d="M225.876 81.916V102.48C225.876 104.369 224.861 106.111 223.216 107.041L131.199 159.033C129.601 159.937 127.644 159.937 126.047 159.033L34.0293 107.041C32.3848 106.111 31.3672 104.369 31.3672 102.48V81.916C31.3672 79.0215 33.7129 76.6758 36.6055 76.6758H220.638C223.533 76.6758 225.876 79.0215 225.876 81.916V81.916Z"
          fill="#FECF8A"
        />
        <path
          d="M247.011 181.617H10.2383C7.3457 181.617 5 183.961 5 186.855V250.762C5 253.654 7.3457 256 10.2383 256H247.011C249.904 256 252.249 253.654 252.249 250.762V186.854C252.247 183.961 249.904 181.617 247.011 181.617Z"
          fill="#B4D2D7"
        />
        <path
          d="M240.2 181.617V233.476C240.2 239.262 235.509 243.953 229.724 243.953H5V250.762C5 253.654 7.3457 256 10.2402 256H247.011C249.904 256 252.249 253.654 252.249 250.762V186.854C252.249 183.961 249.904 181.615 247.011 181.615H240.2V181.617Z"
          fill="#9BB9C3"
        />
        <path
          d="M131.028 1.11328L171.514 49C173.817 51.7246 171.879 55.8965 168.313 55.8965H149.581V113.518C149.581 116.412 147.235 118.756 144.342 118.756H112.913C110.02 118.756 107.674 116.412 107.674 113.518V55.8965H88.9418C85.3735 55.8965 83.4379 51.7246 85.7407 49L126.227 1.11328C127.483 -0.371094 129.772 -0.371094 131.028 1.11328V1.11328Z"
          fill="#00A79F"
        />
        <path
          d="M149.578 55.8965V113.518C149.578 116.412 147.232 118.756 144.34 118.756H140.148V62.1836C140.148 58.7109 142.965 55.8965 146.436 55.8965H149.578Z"
          fill="#006F6A"
        />
        <path
          d="M167.908 55.8965L123.906 3.85156C124.273 3.41602 125.25 2.26172 126.221 1.11328C127.477 -0.371094 129.766 -0.371094 131.021 1.11328L171.508 49C173.811 51.7246 171.873 55.8965 168.307 55.8965H167.908Z"
          fill="#006F6A"
        />
        <path
          d="M128.626 227.189H166.167C167.859 227.189 169.386 226.172 170.036 224.611L177.624 206.398C178.488 204.328 176.966 202.045 174.724 202.045H82.0051C79.7629 202.045 78.2414 204.328 79.1047 206.398L86.6926 224.611C87.343 226.172 88.8703 227.189 90.5617 227.189H128.626Z"
          fill="#87A0AF"
        />
        <path
          d="M90.5481 212.805C89.9719 211.424 90.9875 209.902 92.4816 209.902H176.163L177.624 206.398C178.488 204.328 176.966 202.045 174.724 202.045H82.0051C79.7629 202.045 78.2414 204.328 79.1047 206.398L86.6926 224.611C87.343 226.172 88.8703 227.189 90.5617 227.189H96.5422L90.5481 212.805Z"
          fill="#738C96"
        />
      </g>
      <defs>
        <clipPath id="clip0_8384_50736">
          <rect width="256" height="256" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
